import { useCategoriaMoneda } from "../../utils";
import styles from "./CategoriaLeyendaIpsos.module.scss";

// Textos fijos (decisión de Ignacio, 2026-09-27) — el estudio se hizo en Chile;
// en Perú se cita SIEMPRE aclarando el origen. Nunca props de texto: el país
// sale de useCategoriaMoneda, misma fuente que el resto de /categorias.
const TEXTO_CHILE =
  "Fuente: Ipsos 2025, estudio realizado en la red de Wecast Chile (400 encuestas presenciales, 7 edificios de Santiago)";
const TEXTO_PERU =
  "Fuente: Ipsos 2025, estudio realizado en la red de Wecast Chile (400 encuestas, 7 edificios de Santiago). Los porcentajes son de ese estudio; el inventario, las personas y los montos corresponden a la red de Visiona Perú.";

export const CategoriaLeyendaIpsos = () => {
  const { isPeru } = useCategoriaMoneda();

  return <p className={styles.leyenda}>{isPeru ? TEXTO_PERU : TEXTO_CHILE}</p>;
};

export default CategoriaLeyendaIpsos;
